import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Pipe({
    name: 'imgUrlSanitizer',
    
})
export class ImgUrlSanitizerPipe implements PipeTransform {

  constructor(private domSanitizer: DomSanitizer) { }

  transform(imagen: string): any {

    environment.pathData
    if (!imagen) {
      return environment.pathData + 'assets/image/no-user.png';
    }

    let img = imagen.replace('https', 'http')

    return this.domSanitizer.bypassSecurityTrustResourceUrl(img);
  }
}